import _defineProperty from "/opt/gitlab-runner/builds/4TN/tech/audio/juke-web/juke-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export class Fields {}
_defineProperty(Fields, "cmpId", 'cmpId');
_defineProperty(Fields, "cmpVersion", 'cmpVersion');
_defineProperty(Fields, "consentLanguage", 'consentLanguage');
_defineProperty(Fields, "consentScreen", 'consentScreen');
_defineProperty(Fields, "created", 'created');
_defineProperty(Fields, "supportOOB", 'supportOOB');
_defineProperty(Fields, "isServiceSpecific", 'isServiceSpecific');
_defineProperty(Fields, "lastUpdated", 'lastUpdated');
_defineProperty(Fields, "numCustomPurposes", 'numCustomPurposes');
_defineProperty(Fields, "policyVersion", 'policyVersion');
_defineProperty(Fields, "publisherCountryCode", 'publisherCountryCode');
_defineProperty(Fields, "publisherCustomConsents", 'publisherCustomConsents');
_defineProperty(Fields, "publisherCustomLegitimateInterests", 'publisherCustomLegitimateInterests');
_defineProperty(Fields, "publisherLegitimateInterests", 'publisherLegitimateInterests');
_defineProperty(Fields, "publisherConsents", 'publisherConsents');
_defineProperty(Fields, "publisherRestrictions", 'publisherRestrictions');
_defineProperty(Fields, "purposeConsents", 'purposeConsents');
_defineProperty(Fields, "purposeLegitimateInterests", 'purposeLegitimateInterests');
_defineProperty(Fields, "purposeOneTreatment", 'purposeOneTreatment');
_defineProperty(Fields, "specialFeatureOptins", 'specialFeatureOptins');
_defineProperty(Fields, "useNonStandardStacks", 'useNonStandardStacks');
_defineProperty(Fields, "vendorConsents", 'vendorConsents');
_defineProperty(Fields, "vendorLegitimateInterests", 'vendorLegitimateInterests');
_defineProperty(Fields, "vendorListVersion", 'vendorListVersion');
_defineProperty(Fields, "vendorsAllowed", 'vendorsAllowed');
_defineProperty(Fields, "vendorsDisclosed", 'vendorsDisclosed');
_defineProperty(Fields, "version", 'version');